// src/components/Navbar.jsx
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../access/img/MetrIQlogo.svg";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  // useTheme,
} from "@mui/material";
import {
  OtherHousesOutlinedIcon,
  PeopleAltOutlinedIcon,
  AccountTreeOutlinedIcon,
  AssignmentTurnedInOutlinedIcon,
  QueryBuilderOutlinedIcon,
  AddTaskOutlinedIcon,
  CloudUploadOutlinedIcon,
  SettingsOutlinedIcon,
  LogoutIcon,
  CommentOutlinedIcon,
} from "../access/icons/Icons";

const drawerWidth = 250;
const adminNavItems = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    icon: <OtherHousesOutlinedIcon />,
  },
  { to: "/admin/users", label: "Users", icon: <PeopleAltOutlinedIcon /> },
  {
    to: "/admin/projects",
    label: "Projects",
    icon: <AccountTreeOutlinedIcon />,
  },
  {
    to: "/admin/assing-projects",
    label: "Assign Projects",
    icon: <AssignmentTurnedInOutlinedIcon />,
  },
  {
    to: "/admin/time-tracking",
    label: "Time Tracking",
    icon: <QueryBuilderOutlinedIcon />,
  },
  {
    to: "/admin/my-time",
    label: "My Time",
    icon: <QueryBuilderOutlinedIcon />,
  },
  { to: "/admin/tasks", label: "Tasks", icon: <AddTaskOutlinedIcon /> },
  {
    to: "/admin/files",
    label: "Uploaded Files",
    icon: <CloudUploadOutlinedIcon />,
  },
  { to: "/admin/comments", label: "Comments", icon: <CommentOutlinedIcon /> },
];

const userNavItems = [
  {
    to: "/user/dashboard",
    label: "Dashboard",
    icon: <OtherHousesOutlinedIcon />,
  },
  {
    to: "/user/projects",
    label: "Projects",
    icon: <AccountTreeOutlinedIcon />,
  },
  { to: "/user/my-time", label: "My Time", icon: <QueryBuilderOutlinedIcon /> },
  { to: "/user/tasks", label: "Tasks", icon: <AddTaskOutlinedIcon /> },
  {
    to: "/user/files",
    label: "Uploaded Files",
    icon: <CloudUploadOutlinedIcon />,
  },
  { to: "/user/comments", label: "Comments", icon: <CommentOutlinedIcon /> },
];

function Navbar({ openSidebar, setOpenSidebar }) {
  const location = useLocation();
  const navigate = useNavigate();
  // const theme = useTheme();
  const isMobile = typeof window !== "undefined" && window.innerWidth < 960;
  const role = localStorage.getItem("role");
  const navItems = role === "admin" ? adminNavItems : userNavItems;

  // Kad klikneš link na mobilnom, zatvara meni
  const handleLinkClick = (to) => {
    if (isMobile) setOpenSidebar(false);
    navigate(to);
  };

  return (
    <Drawer
      variant={isMobile ? "temporary" : "persistent"}
      open={openSidebar}
      onClose={() => setOpenSidebar(false)}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#fff",
          borderRight: "1px solid #f1f1f1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "12px 0 8px 0",
        },
      }}
    >
      {/* Gornji deo: logo + navigacija */}
      <Box>
        <Box sx={{ display: "flex", mb: 4, ml: 2 }}>
          <img
            src={logo}
            alt="Vista Logo"
            style={{ width: "140px", marginTop: "6px" }}
          />
        </Box>

        <span
          style={{
            fontSize: 13,
            color: "#888",
            paddingLeft: 15,
          }}
        >
          Menu
        </span>

        <List sx={{ pt: 0.2 }}>
          {navItems.map(({ to, label, icon }) => {
            const active = location.pathname === to;
            return (
              <ListItem
                key={to}
                onClick={() => handleLinkClick(to)}
                sx={{
                  borderRadius: "30px",
                  margin: "2px 10px",
                  padding: "7px 10px",
                  width: "-webkit-fill-available",
                  background: active ? "var(--gradient-color)" : "transparent",
                  color: active ? "#fff" : "#fff",
                  cursor: "pointer",
                  "&:hover": {
                    background: "var(--gradient-color)",
                    "& *": {
                      color: "#fff !important",
                      fill: "#fff !important",
                    },
                  },
                  transition: "all 0.2s ease",
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 36,
                    color: active ? "#fff" : "#888",
                    fontSize: 22,
                  }}
                >
                  {icon}
                </ListItemIcon>
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    fontSize: 16,
                    color: active ? "#fff" : "#555",
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </Box>

      {/* Donji deo: settings + logout */}
      <Box sx={{ mt: "auto", pt: 0.5 }}>
        <List sx={{ pb: 0 }}>
          <ListItem
            onClick={() => handleLinkClick(`/${role}/settings`)}
            sx={{
              borderRadius: "30px",
              margin: "2px 10px",
              padding: "8px",
              width: "-webkit-fill-available",
              color:
                location.pathname === `/${role}/settings` ? "#fff" : "#555",
              background:
                location.pathname === `/${role}/settings`
                  ? "var(--gradient-color)"
                  : "transparent",
              cursor: "pointer",
              "&:hover": {
                background: "var(--gradient-color)",
                "& *": {
                  color: "#fff !important",
                  fill: "#fff !important",
                },
              },
            }}
          >
            <ListItemIcon
              sx={{
                color:
                  location.pathname === `/${role}/settings` ? "#fff" : "#555",
                minWidth: 36,
              }}
            >
              <SettingsOutlinedIcon />
            </ListItemIcon>
            <ListItemText
              primary="Settings"
              primaryTypographyProps={{
                fontSize: 16,
                fontWeight:
                  location.pathname === `/${role}/settings` ? 600 : 400,
              }}
            />
          </ListItem>
          <ListItem
            onClick={() => {
              localStorage.clear();
              window.location.href = "/";
            }}
            sx={{
              borderRadius: "30px",
              margin: "4px 10px",
              width: "-webkit-fill-available",
              padding: "6px 12px",
              color: "#e74c3c",
              cursor: "pointer",
              "&:hover": { background: "var(--gradient-color)" },
            }}
          >
            <ListItemIcon sx={{ minWidth: 36, color: "#e74c3c" }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText
              primary="Logout"
              primaryTypographyProps={{ fontSize: 16, fontWeight: 500 }}
            />
          </ListItem>

          <p
            style={{
              fontSize: 13,
              marginLeft: 25,
              paddingTop: 20,
              fontWeight: 500,
            }}
          >
            Powered by{" "}
            <a href="https://helmchron.com" target="_blank">
              Helmchron
            </a>{" "}
            | v1.0
          </p>
        </List>
      </Box>
    </Drawer>
  );
}

export default Navbar;
